export const flightInfoClasses = {
  smallFonts: 'flight-info-small',
}

export const FLIGHT_LIST_TIME_FORMAT = 'h:mm A'
